import {
  AsbestosDetection,
  AsbestosFinding,
} from '@ivario-arc/shared/src/sampleResults/asbestos.ts';
import { useTranslation } from 'react-i18next';
import AsbestosBannerComponent from '@components/sample-details/AsbestosBannerComponent.tsx';
import { SampleDetailsDto } from '@src/types/types.ts';
import { AsbestosTargetType } from '@src/asbestos/types.ts';
import { getDetection, getPercentageParameter } from '@src/asbestos/utils.ts';

export type AsbestosStatusMessageProps = {
  targetAsbestosKind: AsbestosTargetType;
  onInfoTap: () => void;
  sample: SampleDetailsDto;
};

export const AsbestosStatusMessage = ({
  targetAsbestosKind,
  onInfoTap,
  sample,
}: AsbestosStatusMessageProps) => {
  const { t: tAsbestosValues } = useTranslation('component', {
    keyPrefix: 'parameterList.asbestosValues',
  });

  const { detection, pmId, val } = getDetection(targetAsbestosKind, sample);

  if (!pmId) {
    return null;
  }

  const parameters = sample.parameters.filter(
    (parameter) => parameter.pmId === pmId,
  );
  if (parameters.length === 0) {
    return null;
  }

  const parameter = parameters[0];
  const finding = tAsbestosValues(val);
  const percentageParam = getPercentageParameter(sample);
  const percentage =
    percentageParam && targetAsbestosKind === AsbestosTargetType.ASB
      ? percentageParam.value
      : AsbestosFinding.NOT_POSSIBLE;

  return (
    <AsbestosBannerComponent
      type={
        detection === AsbestosDetection.ASBESTOS ||
        detection === AsbestosDetection.TALK ||
        detection === AsbestosDetection.KMF
          ? 'failure'
          : 'success'
      }
      onInfoClick={onInfoTap}
      proofThreshold={parameter.asbestosProofThreshold}
      procedure={parameter.asbestosProcedure}
      samplePreparation={parameter.asbestosSamplePreparation}
      header={parameter.name}
      finding={`${finding} ${percentage !== AsbestosFinding.NOT_POSSIBLE && percentage !== AsbestosFinding.MINUS ? `(${tAsbestosValues(percentage)})` : ''}`}
    />
  );
};

export { AsbestosTargetType };
